const isCurrentPerformance = (dateNow, datePerformance, offset = 10) => dateNow.isBefore(datePerformance.add(offset, 'minutes'))


export default isCurrentPerformance